import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { ReactComponent as BackIcon } from "../../Assets/Categories/BackIcon.svg";
import SearchBar from "../Main/searchBar";
import { useDispatch, useSelector } from "react-redux";
import { assignProjectToFranchise } from "../../Redux/Actions/franchiseAction";
import toast from "react-hot-toast";
import "./formAssignBuilder.css";

const ACCESS_TYPES = ["list", "view", "edit"];

const FormAssignProjects = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  // Read required IDs and names from Redux store
  const {
    selectedBuilderId: builderId,
    selectedFranchiseId: franchiseId,
    selectedProjectId: projectId,
    selectedProjectName: projectName,
  } = useSelector((state) => state.franchises);

  useEffect(() => {
    console.log("Redux selected state:", {
      builderId,
      franchiseId,
      projectId,
      projectName,
    });
  }, [builderId, franchiseId, projectId, projectName]);

  // ACL fixed to "project"
  const [accessByAcl, setAccessByAcl] = useState({ project: [] });

  // Toggle individual access right for "project" ACL
  const handleAccessToggle = (accessType) => {
    setAccessByAcl((prev) => {
      const currentAccess = prev.project || [];
      const hasAccess = currentAccess.includes(accessType);
      const updatedAccess = hasAccess
        ? currentAccess.filter((a) => a !== accessType)
        : [...currentAccess, accessType];
      return { project: updatedAccess };
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!builderId || !franchiseId || !projectId) {
      toast.error("Missing builder ID, franchise ID or project ID");
      return;
    }
    const projectAccess = accessByAcl.project || [];
    if (projectAccess.length === 0) {
      toast.error("Please select at least one access right for 'Project'");
      return;
    }

    const payload = {
      franchise_id: franchiseId,
      builder_id: builderId,
      project_id: projectId,
      acls: [
        {
          name: "project",
          access: projectAccess,
        },
      ],
    };

    const result = await dispatch(assignProjectToFranchise(payload));
    if (result?.statusCode === 200) {
      toast.success("Project assigned successfully");
      navigate("/franchise/projects_list");
    }
  };

  return (
    <div className="grid-container">
      {/* Search Bar */}
      <div
        className="padding-20"
        style={{ gridColumn: "3/8", marginBottom: 24 }}
      >
        <SearchBar style={{ width: "80%" }} />
      </div>

      {/* Back Icon & Title */}
      <div
        className="back-icon margin-0 gap-12 align-center flex-container"
        style={{
          gridColumn: "span 7",
          marginBottom: 24,
          justifyContent: "space-between",
          borderBottom: "1px solid #ccc",
          paddingBottom: 12,
        }}
      >
        <div style={{ display: "flex", alignItems: "center", gap: 16 }}>
          <Link to={`/franchise/projects_list`}>
            <BackIcon style={{ cursor: "pointer", width: 80, height: 80 }} />
          </Link>
          <h3 style={{ margin: 0, fontWeight: 700, color: "#181E2E" }}>
            Assign Project
          </h3>
        </div>
      </div>

      {/* Form Container */}
      <div
        className="main-div"
        style={{ gridColumn: "1 / -1", leftGap: 20, marginTop: 20 }}
      >
        <div
          className="form-container"
          style={{ width: "80%", margin: "0 auto" }}
        >
          {/* IDs Display */}
          <div className="ids-display" style={{ marginBottom: 24 }}>
            <p>
              <strong style={{ fontSize: "1.2em", fontWeight: "bold" }}>
                Project Name:
              </strong>{" "}
              <span style={{ fontSize: "1.15em", fontWeight: "bold" }}>
                {projectName ?? "No Project Name provided"}
              </span>
            </p>
          </div>

          {/* Form */}
          <form onSubmit={handleSubmit}>
            {/* Fixed ACL = "project" access rights */}
            <div
              className="access-rights-container"
              style={{ marginBottom: 20 }}
            >
              <p className="access-rights-header">
                Access rights for <strong>Project</strong>:
              </p>
              <div className="checkbox-container">
                {ACCESS_TYPES.map((access) => (
                  <label
                    key={access}
                    className="custom-checkbox-label"
                    style={{
                      cursor: "pointer",
                      display: "flex",
                      alignItems: "center",
                      gap: 6,
                    }}
                  >
                    <input
                      type="checkbox"
                      checked={(accessByAcl.project || []).includes(access)}
                      onChange={() => handleAccessToggle(access)}
                    />
                    <span style={{ textTransform: "capitalize" }}>
                      {access}
                    </span>
                  </label>
                ))}
              </div>
            </div>

            <button type="submit" className="submit-button">
              Assign Project
            </button>
          </form>
        </div>
      </div>
    </div>
  );
};

export default FormAssignProjects;
